import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {User} from "../../model/security/user";
import {CrystalclearSecurityBackUrl} from "../config/crystalclear-security-back-url";
import {Observable} from "rxjs";
import {ApiValidation} from "../../model/api/api-validation";
import {FieldRecord} from "../../model/api/field-record";
import {NotifActionTypes} from "../../model/security/notif-action-types";
import {BatchUpdateRequest} from "../../model/api/batch-update-request";
import {SimpleRequest} from "../../model/api/simple-request";

@Injectable({
  providedIn: 'root'
})
export class SecurityUserService extends CommonCrudService<User> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearSecurityBackUrl.GET_SECURITY_USER_LIST,
      CrystalclearSecurityBackUrl.SAVE_SECURITY_USER,
      CrystalclearSecurityBackUrl.DELETE_SECURITY_USER);
  }

  public saveBatch(request: BatchUpdateRequest<User>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSecurityBackUrl.SAVE_SECURITY_USER_BATCH, request);
  }

  public getNotifications(): FieldRecord<FieldRecord<any>>[] {
    const notifications: FieldRecord<FieldRecord<any>>[] = [];
    let items:FieldRecord<any>[] = [new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_ACCOUNT_DEF_CREATE, 'Account Create')
      , new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_ACCOUNT_DEF_UPDATE, 'Account Update')
      , new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_ACCOUNT_DEF_DELETE, 'Account Delete')];
    notifications.push(new FieldRecord('ACCOUNT_DEF', 'Account', items));
    items = [new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_CUSTOMER_CREATE, 'Customer Create')
      , new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_CUSTOMER_UPDATE, 'Customer Update')
      , new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_CUSTOMER_DELETE, 'Customer Delete')];
    notifications.push(new FieldRecord('CUSTOMER', 'Customer', items));
    items = [new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_TRADER_CREATE, 'Trader Create')
      , new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_TRADER_UPDATE, 'Trader Update')
      , new FieldRecord(NotifActionTypes.NotifActionType.CUSTOMER_TRADER_DELETE, 'Trader Delete')];
    notifications.push(new FieldRecord('TRADER', 'Trader', items));

    return notifications;
  }

  public updateInfos(record: User): Observable<ApiValidation<User>> {
    return this.post(CrystalclearSecurityBackUrl.UPDATE_INFOS_SECURITY_USER, record);
  }

  public getUser(username: string): Observable<ApiValidation<User>> {
    return this.post(CrystalclearSecurityBackUrl.GET_SECURITY_USER, new SimpleRequest(username));
  }

  public refreshActivity(user: User): Observable<ApiValidation<User>> {
    return this.post(CrystalclearSecurityBackUrl.SECURITY_REFRESH_ACTIVITY, user);
  }

}
